import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { D as debounce, q as starsToRating, m as transformMyReview, g as getLocale, E as getStructuredReviewData, z as classNames, l as transDialog, k as getTheme } from './utils2.js';
import { d as DIALOG_PAGES, h as MAX_TEXT_LENGTH, i as LAST_TEXT_LENGTH, j as STARS_SIZE } from './const.js';
import { d as defineCustomElement$c } from './mapy-icon2.js';
import { d as defineCustomElement$b } from './mapy-loader2.js';
import { d as defineCustomElement$a } from './mapy-review-button2.js';
import { d as defineCustomElement$9 } from './mapy-review-dialog-footer2.js';
import { d as defineCustomElement$8 } from './mapy-review-photo-item2.js';
import { d as defineCustomElement$7 } from './mapy-review-photos-upload2.js';
import { d as defineCustomElement$6 } from './mapy-review-stars2.js';
import { d as defineCustomElement$5 } from './mapy-review-structured-review2.js';
import { d as defineCustomElement$4 } from './mapy-review-structured-review-item2.js';
import { d as defineCustomElement$3 } from './mapy-review-textarea2.js';
import { d as defineCustomElement$2 } from './mapy-review-tooltip2.js';
import { d as defineCustomElement$1 } from './mapy-review-user2.js';

const mapyReviewDialogPageEditCss = ".mapy-review-dialog-page-edit{padding:0;display:flex;flex-direction:column;position:relative;height:100%;max-height:750px;overflow:hidden;border-radius:12px;font-family:Arial}.scrollable{padding:0 32px 24px 32px;display:flex;flex-direction:column;gap:24px;height:100%;box-sizing:border-box;align-items:center;position:relative;box-sizing:border-box;overflow:auto}.content{display:flex;gap:24px;flex-direction:column;align-items:center;justify-content:center;width:100%}.header{padding:24px;display:flex;flex-direction:column}.title{margin:0;font-size:20px;font-style:normal;font-weight:700;line-height:28px;text-align:center}.review-info{margin:0;font-size:14px;font-style:normal;font-weight:400;line-height:20px;text-align:center}.desc{display:flex;flex-direction:column;justify-content:center;align-items:center;gap:4px}.structuredReview{padding:0 16px;box-sizing:border-box;width:100%}.textArea,.photos{width:100%;box-sizing:border-box}.textArea mapy-review-textarea{width:100%}.footer{position:sticky;left:0;right:0;bottom:0;background:#fff;z-index:10;padding:0 32px;padding-top:24px}.footer.sticky-footer{box-shadow:0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 3px 5px rgba(0, 0, 0, 0.2)}.mapy-review-dialog-page-edit.sticky-header .header{border-bottom:1px solid #F0F0F0}@media only screen and (max-width: 500px){.scrollable{padding:0 16px 12px 16px}.structuredReview{padding:0}.footer{padding:0 16px;padding-top:16px}}";
const MapyReviewDialogPageEditStyle0 = mapyReviewDialogPageEditCss;

var __classPrivateFieldGet = (undefined && undefined.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f)
        throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
        throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (undefined && undefined.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m")
        throw new TypeError("Private method is not writable");
    if (kind === "a" && !f)
        throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
        throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _MapyReviewDialogPageEdit_structuredData, _MapyReviewDialogPageEdit_lang, _MapyReviewDialogPageEdit_scrollElem, _MapyReviewDialogPageEdit_initHash, _MapyReviewDialogPageEdit_delayedChange;
const MapyReviewDialogPageEdit = /*@__PURE__*/ proxyCustomElement(class MapyReviewDialogPageEdit extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.signal = createEvent(this, "signal", 1);
        this.save = createEvent(this, "save", 1);
        this.photoLoading = createEvent(this, "photoLoading", 1);
        this.dataChange = createEvent(this, "dataChange", 1);
        _MapyReviewDialogPageEdit_structuredData.set(this, []);
        _MapyReviewDialogPageEdit_lang.set(this, "");
        _MapyReviewDialogPageEdit_scrollElem.set(this, null);
        _MapyReviewDialogPageEdit_initHash.set(this, "");
        // pro psani textu to chceme opozdit -> nechceme pro kazdy znak
        _MapyReviewDialogPageEdit_delayedChange.set(this, debounce(() => {
            this.sendChangeData();
        }, 500));
        this.onSignal = (signal) => {
            this.signal.emit(signal.detail);
        };
        this.onSave = () => {
            this.save.emit({
                page: DIALOG_PAGES.EDIT,
                rating: starsToRating(this.curRating),
                text: this.reviewText,
                media_ids: this.curPhotos.map(item => item.mediaId),
                photos: this.curPhotos,
                structuredRating: __classPrivateFieldGet(this, _MapyReviewDialogPageEdit_structuredData, "f"),
            });
        };
        this.onFooterSave = () => {
            this.onSave();
        };
        this.onStructuredItemsChange = (event) => {
            __classPrivateFieldSet(this, _MapyReviewDialogPageEdit_structuredData, event.detail.items, "f");
            this.signal.emit({
                name: "structured-review",
                data: __classPrivateFieldGet(this, _MapyReviewDialogPageEdit_structuredData, "f"),
            });
            this.sendChangeData();
        };
        this.onStarsChange = (event) => {
            event.stopPropagation();
            // @ts-ignore
            this.curRating = event.target.value;
            this.signal.emit({
                name: "stars-click",
                rating: this.curRating,
            });
            this.sendChangeData();
        };
        this.onTextChange = (event) => {
            this.reviewText = event.detail;
            __classPrivateFieldGet(this, _MapyReviewDialogPageEdit_delayedChange, "f").call(this);
        };
        this.onUploadStart = (event) => {
            this.photoError = "";
            this.photoLoading.emit(true);
            this.signal.emit({
                name: "upload-start",
                count: event.detail,
            });
        };
        this.onPhotosChange = (event) => {
            this.curPhotos = event.detail.photos;
            this.photoLoading.emit(false);
            this.sendChangeData();
        };
        this.onPhotosError = (event) => {
            this.photoError = event.detail.error;
        };
        this.setRef = (scrollElem) => {
            __classPrivateFieldSet(this, _MapyReviewDialogPageEdit_scrollElem, scrollElem, "f");
        };
        this.onScroll = () => {
            const top = __classPrivateFieldGet(this, _MapyReviewDialogPageEdit_scrollElem, "f").scrollTop;
            this.wasScrolled = top > 0;
        };
        this.onBlurWithText = () => {
            this.signal.emit({
                name: "textarea-blur",
            });
        };
        this.endpoint = "";
        this.apiKey = "";
        this.isFirm = false;
        this.verifiedUser = false;
        this.loading = false;
        this.service = "mapy";
        this.error = "";
        this.user = "";
        this.switchStars = false;
        this.detailData = null;
        this.maxLength = MAX_TEXT_LENGTH;
        this.lastLength = LAST_TEXT_LENGTH;
        this.debug = false;
        this.isResponsive = false;
        this.curPhotos = [];
        this.curRating = 0;
        this.reviewText = "";
        this.photoError = "";
        this.wasScrolled = false;
    }
    sendChangeData() {
        const curHash = this.getHash();
        const change = curHash !== __classPrivateFieldGet(this, _MapyReviewDialogPageEdit_initHash, "f");
        this.dataChange.emit(change);
    }
    getHash() {
        return JSON.stringify([this.curRating, __classPrivateFieldGet(this, _MapyReviewDialogPageEdit_structuredData, "f"), this.reviewText, this.curPhotos]);
    }
    componentWillLoad() {
        const myReview = this.detailData.myReview;
        const transformedData = transformMyReview(myReview);
        __classPrivateFieldSet(this, _MapyReviewDialogPageEdit_lang, getLocale(this.hostElement), "f");
        __classPrivateFieldSet(this, _MapyReviewDialogPageEdit_structuredData, getStructuredReviewData(myReview.structured_rating), "f");
        this.reviewText = myReview.text;
        this.curRating = transformedData.rating;
        this.curPhotos = transformedData.photos;
        __classPrivateFieldSet(this, _MapyReviewDialogPageEdit_initHash, this.getHash(), "f");
    }
    render() {
        const myReview = this.detailData.myReview;
        const theme = getTheme(this.service);
        const structuredArea = myReview.structured_rating.length > 0 && h("div", { key: '3829fb167def5cfd4c36819230c0dadec8cde553', class: "structuredReview" }, h("mapy-review-structured-review", { key: 'b80213f04bb02b9dfbe5627c6daadd8c2763a05b', items: myReview.structured_rating, onChange: this.onStructuredItemsChange, tooltip: false, lang: __classPrivateFieldGet(this, _MapyReviewDialogPageEdit_lang, "f") }));
        const starsArea = h("mapy-review-stars", { key: 'c79402137cd9b8e483b0ba36f0ca3f0818f3eff8', value: this.curRating, size: this.isResponsive ? STARS_SIZE.responsive : STARS_SIZE.normal, onInput: this.onStarsChange, gap: 13, disabled: this.loading });
        const isSmallHeight = window.innerHeight < 750;
        const isStickyFooter = structuredArea || this.wasScrolled || isSmallHeight || this.curPhotos.length > 4;
        const date = new Date(myReview.updated);
        const dateStr = new Intl.DateTimeFormat(__classPrivateFieldGet(this, _MapyReviewDialogPageEdit_lang, "f"), { month: "long", day: "numeric", year: "numeric" }).format(date);
        return (h(Host, { key: '598c28be3080811f8e1176112a0d31b5fc96e1f3' }, h("div", { key: 'ab1227acd4ca586a796076388fb2b28b4d8e91b2', class: classNames(["mapy-review-dialog-page-edit", this.wasScrolled ? "sticky-header" : ""]), "data-theme": theme }, h("div", { key: '1095ee0f7b500ab7baa93f3fbbf10dea7297c4fe', class: "header" }, h("h3", { key: 'a170fe51dff04e9ee7a23a8d15f87de0c775c73e', class: "title" }, this.detailData.title)), h("div", { key: 'b4ac87bd85dec73b0ef5b03cf7a6b7b52913914f', class: "scrollable", onScroll: this.onScroll, ref: this.setRef }, h("div", { key: '40a765f6fab796ec8e53f4a1da1fbbf830e1b141', class: "desc" }, h("p", { key: 'e912ca102c579c1a0132c40464689d37778de3f6', class: "review-info", innerHTML: transDialog(__classPrivateFieldGet(this, _MapyReviewDialogPageEdit_lang, "f"), "editFrom", { date: dateStr }) }), h("mapy-review-user", { key: '9ee26a08f9b04c5c6582cb23a231cb9a5c942264', user: this.user, verifiedUser: this.verifiedUser, onSignal: this.onSignal, lang: __classPrivateFieldGet(this, _MapyReviewDialogPageEdit_lang, "f") })), this.switchStars ? starsArea : structuredArea, this.switchStars ? structuredArea : starsArea, h("div", { key: '79dc171882aebddba5741b1547ec9576dddd3c23', class: "textArea" }, h("mapy-review-textarea", { key: 'f17bf68bff9639ab4e2f87878424bf3a0161f292', value: this.reviewText, onChange: this.onTextChange, height: theme === "mapy" ? 154 : 204, maxLength: this.maxLength, lastLength: this.lastLength, lang: __classPrivateFieldGet(this, _MapyReviewDialogPageEdit_lang, "f"), service: this.service, onBlurWithText: this.onBlurWithText })), h("div", { key: '4d8f2f5d3fb837e3ce27429d977ba7fbeec16ae6', class: "photos" }, h("mapy-review-photos-upload", { key: 'f489b12c2a1ab01b1065894b53237f9e04e3a22d', endpoint: this.endpoint, apiKey: this.apiKey, photos: this.curPhotos, debug: this.debug, onChange: this.onPhotosChange, onError: this.onPhotosError, onUploadStart: this.onUploadStart, lang: __classPrivateFieldGet(this, _MapyReviewDialogPageEdit_lang, "f"), service: this.service, onSignal: this.onSignal }))), h("div", { key: '5c4ee2b37afe4d165c8f757fc69438466f3953d2', class: classNames(["footer", isStickyFooter ? "sticky-footer" : ""]) }, h("mapy-review-dialog-footer", { key: '9fb1d40b7464c9e6c150bb69a38426a0bd1cdaaf', isFirm: this.isFirm, hasButton: true, loading: this.loading, disabled: this.loading, isEditMode: true, hasPhotos: this.curPhotos.length > 0, onSave: this.onFooterSave, onSignal: this.onSignal, lang: __classPrivateFieldGet(this, _MapyReviewDialogPageEdit_lang, "f"), service: this.service, error: this.photoError || this.error })))));
    }
    get hostElement() { return this; }
    static get style() { return MapyReviewDialogPageEditStyle0; }
}, [1, "mapy-review-dialog-page-edit", {
        "endpoint": [513],
        "apiKey": [513, "api-key"],
        "isFirm": [516, "is-firm"],
        "verifiedUser": [516, "verified-user"],
        "loading": [516],
        "service": [513],
        "error": [513],
        "user": [513],
        "switchStars": [516, "switch-stars"],
        "detailData": [16],
        "maxLength": [514, "max-length"],
        "lastLength": [514, "last-length"],
        "debug": [516],
        "isResponsive": [516, "is-responsive"],
        "curPhotos": [32],
        "curRating": [32],
        "reviewText": [32],
        "photoError": [32],
        "wasScrolled": [32]
    }]);
_MapyReviewDialogPageEdit_structuredData = new WeakMap(), _MapyReviewDialogPageEdit_lang = new WeakMap(), _MapyReviewDialogPageEdit_scrollElem = new WeakMap(), _MapyReviewDialogPageEdit_initHash = new WeakMap(), _MapyReviewDialogPageEdit_delayedChange = new WeakMap();
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["mapy-review-dialog-page-edit", "mapy-icon", "mapy-loader", "mapy-review-button", "mapy-review-dialog-footer", "mapy-review-photo-item", "mapy-review-photos-upload", "mapy-review-stars", "mapy-review-structured-review", "mapy-review-structured-review-item", "mapy-review-textarea", "mapy-review-tooltip", "mapy-review-user"];
    components.forEach(tagName => { switch (tagName) {
        case "mapy-review-dialog-page-edit":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, MapyReviewDialogPageEdit);
            }
            break;
        case "mapy-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$c();
            }
            break;
        case "mapy-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$b();
            }
            break;
        case "mapy-review-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$a();
            }
            break;
        case "mapy-review-dialog-footer":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "mapy-review-photo-item":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "mapy-review-photos-upload":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "mapy-review-stars":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "mapy-review-structured-review":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "mapy-review-structured-review-item":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "mapy-review-textarea":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "mapy-review-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "mapy-review-user":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { MapyReviewDialogPageEdit as M, defineCustomElement as d };

//# sourceMappingURL=mapy-review-dialog-page-edit2.js.map